import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={goTop}
      data-testid="back-to-top"
      className={`fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 rounded-full border-2 border-[#E6A95B] bg-[#0A0A0C]/90 backdrop-blur text-[#E6A95B] grid place-items-center shadow-[0_10px_50px_-10px_rgba(230,169,91,0.7)] transition-all duration-300 hover:bg-[#E6A95B] hover:text-[#0A0A0C] hover:shadow-[0_0_60px_-5px_rgba(230,169,91,0.9)] hover:scale-110 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-6 h-6 md:w-7 md:h-7" strokeWidth={2.5} />
    </button>
  );
};

export default BackToTop;
